'use client';

import React, { memo } from 'react';

import { LocationSearchInput } from '@ui/components/features/locationSearch/locationSearchInput';

interface MemoizedLocationSearchInputProps {
  placeholder: string;
  value: string;
  className?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
}

export const MemoizedLocationSearchInput = memo<MemoizedLocationSearchInputProps>(
  ({ placeholder, value, className, onChange, autoFocus, inputRef }) => {
    return (
      <LocationSearchInput
        ref={inputRef}
        placeholder={placeholder}
        value={value}
        className={className}
        onChange={onChange}
        autoFocus={autoFocus}
      />
    );
  }
);

MemoizedLocationSearchInput.displayName = 'MemoizedLocationSearchInput';
